export default __webpack_public_path__ + "static/media/dropdown.5dc00752.svg";